import {createDivIn, createImgIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {SocketDataTypes} from '../../../../../shared/SocketDataTypes'
import {RoomSettingConstants} from '@colonist/game-base-types'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'

export class UILobbyTableRowHighKarmaController {
    private readonly highKarma: HTMLDivElement

    constructor(container: HTMLTableCellElement, roomData: SocketDataTypes.LobbyRowData) {
        this.highKarma = createDivIn(container, 'high_karma_icon')
        this.update(roomData.minimumKarma)
    }

    update(minimumKarma: number, oldRoomData?: SocketDataTypes.LobbyRowData) {
        if(!UILobbyTableRowHighKarmaController.changedHighKarmaData(minimumKarma, oldRoomData)) return
        this.removeHighKarma()
        if(UILobbyTableRowHighKarmaController.isHighKarmaRoom(minimumKarma)) this.addHighKarma()
    }

    private removeHighKarma() {
        setElementInnerHTML(this.highKarma, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    private addHighKarma() {
        const karmaImage = createImgIn(this.highKarma, LobbyImage.IconNoTroll)
        createTooltipIn(karmaImage, {key: 'strings:roomPage.options.highKarmaGame.title'})
    }

    private static changedHighKarmaData(minimumKarma: number, oldRoomData?: SocketDataTypes.LobbyRowData): boolean {
        if(oldRoomData == undefined) return true
        if(oldRoomData.minimumKarma != minimumKarma) return true
        return false
    }

    private static isHighKarmaRoom(minimumKarma: number): boolean {
        return minimumKarma == RoomSettingConstants.HIGH_KARMA_THRESHOLD
    }
}
